import api from './axios';

const BASE = '/customers';

export const getCustomers = (page = 0, size = 10, filters = {}) =>
  api.get(BASE, { params: { page, size, ...filters } });

export const getCustomer = (id) => api.get(`${BASE}/${id}`);

export const updateCustomer = (id, data) => api.put(`${BASE}/${id}`, data);
